import React from "react";
import ServiceHighlight from "./ServiceHighlight";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const WhyChooseSection = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const sectionData = labels.menuPages?.sellCar?.whyChooseSection || {};
  const sellerBenefits = sectionData.sellerBenefits?.items || [];
  const serviceFeatures = sectionData.serviceFeatures?.items || [];

  return (
    <div className="bg-gradient-to-r from-emerald-600 to-cyan-600 rounded-3xl p-12 text-white text-center max-w-6xl mx-auto">
      <h3 className="text-3xl md:text-4xl font-bold mb-6">
        {sectionData.title || "Varför Välja BILENIA & BEA Auktioner?"}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left max-w-4xl mx-auto">
        <ServiceHighlight
          title={sectionData.sellerBenefits?.title || "För Dig Som Säljare:"}
          items={sellerBenefits}
        />
        <ServiceHighlight
          title={sectionData.serviceFeatures?.title || "Vår Service:"}
          items={serviceFeatures}
        />
      </div>
    </div>
  );
};

export default WhyChooseSection;
